import { AuthorizationServer, Client } from 'oauth4webapi'

export const getServer = (issuer: string): AuthorizationServer => {
    return {
        issuer,
        authorization_endpoint: `${issuer}/auth`,
        end_session_endpoint: `${issuer}/session/end`,
        jwks_uri: `${issuer}/jwks`,
        token_endpoint: `${issuer}/token`,
        userinfo_endpoint: `${issuer}/userInfo`,
        introspection_endpoint: `${issuer}/token/introspection`,
        revocation_endpoint: `${issuer}/token/revocation`,
    }
}

export const getClient = (clientId: string): Client => {
    return {
        client_id: clientId,
        token_endpoint_auth_method: 'none',
    }
}
